<template>
    <b-container fluid class="animated fadeIn">
        <h1>Exibir Petição</h1>
        <b-card>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Nome do Autor:" label-for="nomeAutor" class="text-label">
                        <b-form-input 
                            name="nomeAutor"
                            v-model="peticao.nomeAutor" 
                            type="text" 
                            :disabled="true"/>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Tipo de Crédito:" label-for="tipoCredito" class="text-label">
                        <b-form-select
                            name="tipoCredito"
                            v-model="peticao.tipoCredito"
                            :value="peticao.tipoCredito"
                            :disabled="true">
                            <template v-slot:first>
                                <option :value="null" disabled>-- Selecione --</option>
                            </template>
                            <option 
                                v-for="tc in dados.tiposCredito" 
                                :key="tc.id"
                                :value="tc">
                                {{ tc.nome ? tc.nome : 'NENHUM' }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="CNPJ:" label-for="cnpjAutor" class="text-label">
                        <b-form-input 
                            name="cnpjAutor"
                            v-model="peticao.cnpjAutor" 
                            type="text" 
                            v-mask="'XX.XXX.XXX/XXXX-##'"
                            :disabled="true"/>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <div class="form-group text-label">
                        <label for="textoPadrao" class="d-block">Texto Padrão: 
                            <i  id="infoTextoPadrao" style="color: #007bff" class="fa fa-info-circle fa-lg pl-2" />
                        </label>
                        <b-tooltip target="infoTextoPadrao" variant="secondary" placement="rightbottom">
                            <strong>Tags</strong>
                            <hr class="p-0 m-0 pb-1 mt-1">
                            <div class="justify-content-between" style="text-align: left">
                                <p class="p-0 m-0" v-for="dados in dados.tags" :key="dados.id">
                                    {{ dados.id }} - {{ dados.nome }}
                                </p>
                            </div>
                        </b-tooltip>
                        <b-form-textarea
                            id="textoPadrao"
                            name="textoPadrao"
                            v-model="peticao.textoPadrao"
                            rows="10"
                            max-rows="10"
                            :disabled="true"
                        ></b-form-textarea>
                    </div>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="CEP:" label-for="cepAutor" class="text-label">
                        <b-form inline>
                            <b-form-input 
                                name="cepAutor"
                                v-model="peticao.cepAutor" 
                                type="text" 
                                v-mask="['#####-###']"
                                :disabled="true" />
                        </b-form>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="8" lg="8" xl="8">
                    <b-form-group label="Endereço do Autor:" label-for="enderecoAutor" class="text-label">
                        <b-form-input 
                            name="enderecoAutor"
                            v-model="peticao.enderecoAutor" 
                            type="text" 
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Complemento:" label-for="complementoAutor" class="text-label">
                        <b-form-input 
                            name="complementoAutor"
                            v-model="peticao.complementoAutor" 
                            type="text" 
                            :disabled="true" />
                    </b-form-group>
                </b-col>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Bairro:" label-for="bairroAutor" class="text-label">
                        <b-form-input 
                            name="bairroAutor"
                            v-model="peticao.bairroAutor" 
                            type="text" 
                            :disabled="true" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group label="Município:" label-for="municipio" class="text-label">
                        <b-form-select
                            name="municipio"
                            v-model="peticao.municipio"
                            :value="peticao.municipio"
                            :disabled="true">
                            <template v-slot:first>
                                <option :value="null" disabled>-- Selecione --</option>
                            </template>
                            <option 
                                v-for="municipio in dados.municipios" 
                                :key="municipio.codMunicipio"
                                :value="municipio">
                                {{ municipio.nome }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="8" sm="8" md="8" lg="8" xl="8">
                    <b-tabs content-class="mt-3" fill>
                        <b-tab title="Tipos de Texto" active>
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <b-pagination v-model="configTableTipoTexto.currentPage" :per-page="configTableTipoTexto.perPage" :total-rows="configTableTipoTexto.rows" size="sm" class="pl-3" style="float:right" v-if="configTableTipoTexto.perPage != 'Todos'">
                                        </b-pagination>
                                        <b-form-select v-model="configTableTipoTexto.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                    </div>
                                </b-col>
                            </b-row>
                            <TabelaTipoTexto
                                :dados="peticao.listaTextoTipoPeticao"
                                :fields="fieldsTipoTexto"
                                :configTable="configTableTipoTexto" />
                            <b-row class="d-flex justify-content-between">
                                <b-col></b-col>
                                <b-col>
                                    <div>
                                        <div>
                                            <b-pagination v-model="configTableTipoTexto.currentPage" :per-page="configTableTipoTexto.perPage" :total-rows="configTableTipoTexto.rows" size="sm" class="pl-3" style="float:right" v-if="configTableTipoTexto.perPage != 'Todos'">
                                            </b-pagination>
                                            <b-form-select v-model="configTableTipoTexto.perPage" :options="[100, 500, 1000, 'Todos']" size="sm" class="mb-3 col-3" style="float:right"></b-form-select>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </b-tab>
                    </b-tabs>
                </b-col>
            </b-row>
             <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-form-group
                        id="groupAtivo"
                        label="Situação: *"
                        label-for="ativo">
                        <b-form-checkbox :disabled="true" switch v-model="peticao.indAtivo">{{ peticao.indAtivo ? 'Ativo' : 'Inativo'}}</b-form-checkbox>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col xs="12" sm="12" md="4" lg="4" xl="4">
                    <b-button variant="primary" class="ml-2" @click="voltar">
                        <i class="fa fa-reply"></i> Voltar
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import TabelaTipoTexto from './TabelaTipoTexto'

export default {
    name: 'ManterPeticaoExibir',
    components: {
        TabelaTipoTexto
    },
    data() {
        return {
            tipoTexto: {
                codTextoTipoPeticao: null,
                tipoTextoPeticao: null,
                textoPeticao: null,
                notacao: null
            },
            peticao: {
                codTipoPeticao: null,
                nomeAutor: null,
                tipoCredito: null,
                cnpjAutor: null,
                textoPadrao: null,
                cepAutor: null,
                enderecoAutor: null,
                complementoAutor: null,
                bairroAutor: null,
                municipio: null,
                indAtivo: true,
                listaTextoTipoPeticao: []
            },
            dados: {
                municipios: [],
                tiposCredito: [],
                tiposTexto: [],
                tags: []
            },
            configTableTipoTexto: {
                perPage: 100,
                currentPage: 1,
                rows: 0,
                msgEmpty: 'Nenhum Tipo de Texto encontrado.'
            },
            fieldsTipoTexto: [
                {
                    key: 'tipoTextoPeticao.nome',
                    label: 'Tipo de Texto',
                    class: 'text-center'
                },
                {
                    key: 'textoPeticao',
                    label: 'Texto'
                },
                {
                    key: 'notacao',
                    label: 'Notação'
                },
            ],
        }
    },
    watch: {
        getTiposTexto() {
            this.atualizarTabelas()
        },
    },
    computed: {
        getTiposTexto() {
            return this.peticao.listaTextoTipoPeticao
        },
    },
    methods: {

        voltar() {
            this.$store.commit("setPeticao", null);
            this.$router.push({ path: '/peticao' })
        },


        validarParametrosTipoTexto(tipoTexto) {
            let valido = true
            if(tipoTexto) {
                if(!tipoTexto.tipoTextoPeticao) valido = false
                if(!tipoTexto.textoPeticao) valido = false
            } else {
                valido = false
            }
            return valido
        },

        atualizarTabelas() {
            this.configTableTipoTexto.rows = this.peticao.listaTextoTipoPeticao.length
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Listar municípios
         */
        async listarMunicipios() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/municipio/listarPR`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.municipios = response.data
            })
        },

        /**
         * Listar tipos de crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/peticao/listarTipoCredito`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.tiposCredito = response.data
            })
        },

        /**
         * Listar tipos de textos
         */
        async listarTipoTexto() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/peticao/listarTipoTexto`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.tiposTexto = response.data
            })
        },

        /**
         * Listar tags de textos
         */
        async listarTags() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/peticao/listarTagsTexto`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.tags = response.data
            })
        },

        async obterPeticao(codTipoPeticao) {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            await axios.post(`${urlApi}/v1/peticao/obter`, codTipoPeticao, {
                headers: {
                    'Authorization': token,
                    'Content-Type': 'application/json',
                }
            })
            .then(response => {
                this.peticao = response.data
            }).catch((error) => {
                this.exibirErro(error)
            })
        },
    },
    mounted() {
        this.$store.commit("setMessages", {});

        const peticaoEditada = this.$store.getters.getPeticao;
        if(peticaoEditada) {
            this.obterPeticao(peticaoEditada.codTipoPeticao)
        }

        this.listarMunicipios()
        this.listarTipoCredito()
        this.listarTipoTexto()
        this.listarTags()
        this.atualizarTabelas()

    }
    
}
</script>

<style scoped>

</style>